import { constant, map } from 'lodash/fp';
import { options as fuelTypeOptions } from 'helpers/fieldOptions/car/fuelType';
import { FUEL_TYPE_NAME } from '../../../../../../constants';

const filterInput = constant({ type: 'string' });

const fuelTypeOptionsAsCheckboxes = map(({ name, value, ...rest }) => ({
  ...rest,
  name,
  value: { [name]: true },
}))(fuelTypeOptions);

export default {
  filterInput,
  name: () => FUEL_TYPE_NAME,
  clearable: () => true,
  options: () => fuelTypeOptionsAsCheckboxes,
  placeholder: () => __('search.filters.any'),
};
